var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field-money',{class:_vm.compacto ? '' : _vm.campo,attrs:{"value":_vm.value,"label":_vm.label,"properties":_vm.propriedades,"options":_vm.opcoes},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }